import React, { useEffect, useState } from "react";
import { useTable, usePagination } from "react-table";
import { ReactComponent as CopyIcon } from "../../../../assets/icons/CopyIcon.svg";
import { ReactComponent as BrandCopyIcon } from "../../../../assets/icons/BrandCopyIcon.svg";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import { Pagination } from "@mui/material";
import Card from "../../../../reusableComponents/Card";
import Calendar from "../../../../reusableComponents/Calendar";
import DropdownIcon from "../../../../assets/icons/dropdown-arrow-gray.svg";
import InvoiceIcon from "../../../../assets/icons/download.svg";
import {
  baseUrl,
  getPaymentList,
  getPaymentListNew,
} from "../../../../utils/api/apis";
import { TruncateString } from "../../../../utils/helpers/string";
import {
  formatNumber,
  FormatUSD,
  statusClassMap,
} from "../../../../utils/string";
import "./style.scss";
import LoaderOverlay from "../../../Loader";
import axios from "axios";

function PaymentHistoryTable({ userDetails }) {
  const { idToken } = useSelector((state) => state.auth);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState([
    new Date(),
    new Date(),
  ]);
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10); // Default page size
  const email = userDetails?.email;
  const [isLoading, setIsLoading] = useState(false);
  const { selectedBrand } = useSelector((state) => state.brand);
  const [payoutData, setPayoutData] = useState(null);

  const fetchData = async (page) => {
    try {
      setIsLoading(true);
      const res = await getPaymentListNew(
        idToken,
        {
          context: 'user_list',
          search: email,
          page: page,
          page_size: pageSize,
        },
        selectedBrand
      );
      setTableData(res?.data?.results || []);
      setTotalPages(Math.ceil((res?.data?.count || 0) / pageSize));
    } catch (error) {
      console.error("Error fetching payment data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [email, currentPage]);

  const fetchTotalPayoutData = async () => {
    try {
      const res = await axios.get(
        `${baseUrl}auth/admin/users/history/${email}/`,
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      setPayoutData(res);
    } catch (error) {
      console.error("error", error);
      throw error;
    }
  };

  useEffect(() => {
    fetchTotalPayoutData();
  }, []);

  return (
    <Card className="paymenthistory_table">
      <div className="table_wrapper">
        <div className="table_header">
          <p>Payment History</p>
          <div className="payoutData">
            <div className="upper">
              <p>
                Total spend -{" "}
                {formatNumber(payoutData?.data[0]?.total_spend) || 0}
              </p>
              <p>
                Total payouts requested -{" "}
                {formatNumber(payoutData?.data[0]?.total_payout_requested) || 0}
              </p>

              <p>
                Total payouts approved -{" "}
                {formatNumber(payoutData?.data[0]?.total_payout_approved) || 0}
              </p>
            </div>

            <div className="lower">
              <p>
                Total failed transactions -{" "}
                {Number(payoutData?.data[0]?.total_failed_transactions).toFixed(
                  0
                ) || 0}
              </p>
              <p>
                Total successful transactions -{" "}
                {Number(
                  payoutData?.data[0]?.total_successful_transactions
                ).toFixed(0) || 0}
              </p>
            </div>
          </div>
          <div className="select_wrapper">
            {/* <div
              className="calendar-button"
              onClick={() => setIsCalendarVisible((prev) => !prev)}
            >
              <img src={DropdownIcon} alt="calendar icon" />
              <p>
                {moment.utc(selectedDateRange[0]).format("MMM D")} -{" "}
                {moment.utc(selectedDateRange[1]).format("MMM D")}
              </p>
            </div> */}
            {/* {isCalendarVisible && (
              <div className="calendar_wrapper">
                <Calendar
                  onChange={(range) => setSelectedDateRange(range)}
                  value={selectedDateRange}
                  selectRange={true}
                  showNeighboringMonth={false}
                />
              </div>
            )} */}
          </div>
        </div>
        <div className="table_scroll_wrapper">
          {isLoading && <LoaderOverlay />}
          <Table
            tableData={tableData}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </Card>
  );
}

const Table = ({ tableData, currentPage, totalPages, onPageChange }) => {
  const handleCopyToClipboard = (text) => {
    toast("Copied Transaction Id", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };
  const { selectedBrand } = useSelector((state) => state.brand);
  const columns = React.useMemo(
    () => [
      { Header: "Account", accessor: "account" },
      {
        Header: (
          <>
            <div className="column_header">
              {" "}
              Challenge Type <img src={DropdownIcon} alt="arrow-down" />{" "}
            </div>
          </>
        ),
        accessor: "funding_evaluation",
      },
      {
        Header: "Plan",
        accessor: "plan",
        Cell: ({ value }) => value,
      },
      {
        Header: (
          <>
            <div className="column_header">
              Transaction Id <img src={DropdownIcon} alt="arrow-down" />
            </div>
          </>
        ),
        accessor: "payment_id",
        Cell: ({ value }) => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "12px",
                alignItems: "center",
              }}
            >
              {TruncateString(value, 20)}
              <CopyToClipboard onCopy={handleCopyToClipboard} text={value}>
                {/* <button> */}
                {/* <p
                  className="table_copy_button"
                  style={{
                    marginRight: "20px",
                    // backgroundColor: "#35d269",
                    cursor: "pointer",
                  }}
                  // onClick={() => handleCopyToClipboard(row.original?.payment_id)}
                >
                  <ContentCopyIcon sx={{fontSize: "20px", backgroundColor: "#35d269", color: "black"}} />
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="12" fill="#FFF" />
                    <path
                      d="M17.886 12.574C18 12.2987 18 11.9487 18 11.25C18 10.5513 18 10.2013 17.886 9.926C17.8106 9.74395 17.7001 9.57854 17.5608 9.43922C17.4215 9.29989 17.256 9.18938 17.074 9.114C16.7987 9 16.4487 9 15.75 9H11.4C10.56 9 10.14 9 9.81933 9.16333C9.53684 9.30719 9.30719 9.53684 9.16333 9.81933C9 10.1393 9 10.5593 9 11.4V15.75C9 16.4487 9 16.7987 9.114 17.074C9.26667 17.4413 9.55867 17.734 9.926 17.886C10.2013 18 10.5513 18 11.25 18C11.9487 18 12.2987 18 12.574 17.886M17.886 12.574C17.8106 12.756 17.7001 12.9215 17.5608 13.0608C17.4215 13.2001 17.256 13.3106 17.074 13.386C16.7987 13.5 16.4487 13.5 15.75 13.5C15.0513 13.5 14.7013 13.5 14.426 13.614C14.244 13.6894 14.0785 13.7999 13.9392 13.9392C13.7999 14.0785 13.6894 14.244 13.614 14.426C13.5 14.7013 13.5 15.0513 13.5 15.75C13.5 16.4487 13.5 16.7987 13.386 17.074C13.3106 17.256 13.2001 17.4215 13.0608 17.5608C12.9215 17.7001 12.756 17.8106 12.574 17.886M17.886 12.574C17.5275 13.8107 16.8678 14.9391 15.9661 15.8582C15.0645 16.7774 13.9489 17.4585 12.7193 17.8407L12.574 17.886M15 9V8.4C15 7.56 15 7.14 14.8367 6.81933C14.693 6.53694 14.4636 6.3073 14.1813 6.16333C13.86 6 13.44 6 12.6 6H8.4C7.56 6 7.14 6 6.81933 6.16333C6.53684 6.30719 6.30719 6.53684 6.16333 6.81933C6 7.13933 6 7.55933 6 8.4V12.6C6 13.44 6 13.86 6.16333 14.1807C6.30733 14.4633 6.53667 14.6927 6.81933 14.8367C7.13933 15 7.56 15 8.40067 15H9"
                      stroke="#36D66B"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p> */}
                <p
                  className="table_copy_button"
                  style={{
                    marginRight: "20px",
                    cursor: "pointer",
                  }}
                >
                  {selectedBrand?.brand === "crypto_edge" ? (
                    <BrandCopyIcon />
                  ) : (
                    <CopyIcon />
                  )}
                </p>
                {/* </button> */}
              </CopyToClipboard>
            </div>
          );
        },
      },
      {
        Header: (
          <>
            <div className="column_header">
              Date <img src={DropdownIcon} alt="arrow-down" />
            </div>
          </>
        ),
        accessor: "created_at",
        Cell: ({ value }) => moment.utc(value).format("MMM Do YYYY, h:mm:ss a"),
        sortType: "datetime",
      },
      {
        Header: (
          <>
            <div className="column_header">
              Amount <img src={DropdownIcon} alt="arrow-down" />
            </div>
          </>
        ),
        accessor: "amount",
        Cell: ({ value }) => "$" + value,
      },
      {
        Header: (
          <>
            <div className="column_header">Promo</div>
          </>
        ),
        accessor: "promo",
        Cell: ({ value }) => value,
      },

      {
        Header: "Invoice",
        accessor: "invoice",
        Cell: ({ value }) =>
          value ? (
            <a href={value} target="_blank" rel="noreferrer">
              <img src={InvoiceIcon} alt="download icon" />
            </a>
          ) : (
            "-"
          ),
      },
      {
        Header: "Status",
        accessor: "payment_status",
        Cell: ({ value, row }) => (
          <span className={`status_wrapper ${statusClassMap[value]}`}>
            {value.toUpperCase()}
          </span>
        ),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: tableData,
        manualPagination: true,
        pageCount: totalPages,
      },
      usePagination
    );

  const handleCopyNotification = () => {
    toast.success("Copied Transaction ID", { theme: "dark" });
  };

  return (
    <div>
      <table {...getTableProps()} className="payment_table">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(e, page) => onPageChange(page)}
        color="primary"
        variant="outlined"
      />
    </div>
  );
};

export default PaymentHistoryTable;
